module.exports = __webpack_public_path__ + "static/media/invalid.d5bb5f1b.svg";